import React, { useState } from 'react';
import WIFIIcon from './icon/WIFI_Icon';
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../actions/ApiGo';
import PopConfirm from '../../popUp/PopConfirm';

const RowBarNode = (props) => {
  const { t, i18n } = useTranslation();
  const _data = props.data;
  const _time = new Date(_data.updated_at || Date.now());

  // 使用 Intl 依 locale 格式化日期與時間（會跟著語言切換）
  const locale = i18n.language || 'en';
  const dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
  const _update_date = new Intl.DateTimeFormat(locale, dateOptions).format(_time);
  const _update_time = new Intl.DateTimeFormat(locale, timeOptions).format(_time);

  const dash = (val) => (val !== null && val !== undefined && val !== '' && val !== 0) ? val : t('common.dash', { defaultValue: '-' });

  // pop 確認視窗
  const [pop, setPop] = useState({
    open: false,
    content: '',
    parameter: []
  });

  function togglePop() {
    setPop({
      open: false,
      content: '',
      parameter: []
    });
  }

  function deletePad(_l, _r, _d) {
    const mac = `${_l}_${_r}_${_d}`;
    ApiGo.deleteSmart_pad(_l)
      .then(res => {
        return ApiGo.remove_tr(mac);
      })
      .then(res => {
        console.log(res);
        props.setRefresh(true);
      })
      .catch(err => {
        console.log(err);
        // 嘗試移除 tr（失敗也繼續嘗試）
        ApiGo.remove_tr(mac)
          .then(res => { console.log(res); props.setRefresh(true); })
          .catch(e => { console.log(e); props.setRefresh(true); });
      });
  }

  function padName() {
    const pads = [
      _data.mac,
      _data.pad_mac_right,
      _data.pad_mac_down,
    ].filter((v, i, arr) => v !== null && v !== undefined && v !== '' && arr.indexOf(v) === i);

    if (pads.length === 0) return <div>{dash(null)}</div>;

    return (
      <>
        {pads.map((pad, idx) => (
          <div key={idx}>{dash(pad)}</div>
        ))}
      </>
    );
  }

  return (
    <div className="fx-d-r font-m fx-cspar wid-admin-90 hig-s hig-s row_hover">
      {pop.open ?
        <PopConfirm
          title={t('devices.delete_title')}
          content={pop.content}
          hide={togglePop}
          callBack={deletePad}
          parameter={pop.parameter}
        /> : null
      }

      <div className="fx-d-r fx-cspar wid-admin-8s">
        <div className="trans_y10"><WIFIIcon rssi={_data.rssi} size={"s"} /></div>
        <div className='w-20 fx-ccc'>{dash(_data.alert_type_id)}</div>
      </div>

      <div className="fx-cc margr-xs wid-admin-xs"><div>{dash(_data.essid)}</div></div>

      <div className="fx-d-c fx-cc wid-admin-xs">
        <div className="fx-d-c fx-cspar">
          <div>{dash(_data.first_name)}</div>
          <div>{dash(_data.last_name)}</div>
        </div>
      </div>

      <div className="fx-d-c fx-cc wid-admin-s">{padName()}</div>

      <div className="fx-d-c fx-cc margr-xs wid-admin-xs">
        <div>{_data.rssi !== null && _data.rssi !== undefined ? `${_data.rssi} ${t('unit.dbm', { defaultValue: 'dBm' })}` : dash(null)}</div>
      </div>

      <div className="fx-d-c fx-cc margr-xs wid-admin-xs">
        <div>{_data.rssi_count !== null && _data.rssi_count !== undefined ? _data.rssi_count : dash(null)}</div>
      </div>

      <div className="fx-cc margr-xs wid-admin-xs">
        {dash(_data.offline_count)}
      </div>

      <div className="fx-cc margr-xs wid-admin-xs">{_data.reconnect_avg_time ? `${_data.reconnect_avg_time}${t('unit.seconds', { defaultValue: 's' })}` : dash(null)}</div>

      <div className="fx-cc margr-xs wid-admin-xs fx-d-c">
        <div>{_update_date || dash(null)}</div>
        <div>{_update_time || dash(null)}</div>
      </div>

      <div className='fx-ccc margr-xs wid-admin-xs fx-d-c'>
        <div
          className="font-m pad-5 l r b t bgC-alert-EE cursor pt br-10 shadow-xs"
          onClick={() => {
            setPop({
              open: true,
              content: t('devices.delete_confirm', { mac: _data.mac || '' }),
              parameter: [_data.mac, _data.pad_mac_right, _data.pad_mac_down]
            });
          }}
        >
          {t('RESIDENTS.DELETE')}
        </div>
      </div>
    </div>
  );
};

export default RowBarNode;